import clsx from 'clsx';

import { formatPriceWithEuro } from '../../utils/StringUtils';
import { calculateTotalToPay } from '../../utils/order/orderUtils';

export default function CartTotalSection({ cartItems, isJackpotMatchUsable }) {
    const hasPromo = cartItems.promoPrice !== cartItems.itemsPrice;

    const jackpotMatchAmount = isJackpotMatchUsable ? cartItems?.jackpot?.amount || 0 : 0;
    const totalToPay = calculateTotalToPay(cartItems.itemsPrice, cartItems.promoPrice, jackpotMatchAmount);

    return (
      <div className="mb-6">
        <div className={clsx("bg-gray-100 flex flex-col gap-4", {
          "pt-5": hasPromo || isJackpotMatchUsable,
        })}>
        {hasPromo || isJackpotMatchUsable ?
          <div className="flex justify-between items-center px-5 pt-2 pb-4 border-t-0 border-x-0 border-b border-solid border-[#e1e0e0]">
            <div className="text-[18px] geomanistBook text-black">Total</div>
            <div className="text-[18px] geomanistBold text-black">
              {formatPriceWithEuro(cartItems.itemsPrice)}
            </div>
          </div> : null}

        {hasPromo ?
          <div className="flex justify-between items-center px-5 pb-4 border-t-0 border-x-0 border-b border-solid border-[#e1e0e0]">
            <div className="text-[18px] geomanistBook text-black">Promo</div>

            <div className="flex items-center gap-2">
              <span className="text-[16px] geomanistBook bg-[#f5202099] text-white rounded p-2"> - {formatPriceWithEuro(cartItems.itemsPrice - cartItems.promoPrice)}</span>
            </div>
          </div> : null}

        {isJackpotMatchUsable ?
          <div className="flex justify-between items-center px-5 pb-4 border-t-0 border-x-0 border-b border-solid border-[#e1e0e0]">
            <div className="text-[18px] geomanistBook text-black">Cagnotte</div>

            <div className="flex items-center gap-2">
              <span className="text-[16px] geomanistBook bg-[#ba38f799] text-white rounded p-2"> - {formatPriceWithEuro(cartItems?.jackpot?.amount)}</span>
            </div>
          </div> : null}

        {cartItems?.jackpot?.isActive && !cartItems?.jackpot?.isAvailable ?
          <div className="flex justify-between items-center px-5 pb-4 border-t-0 border-x-0 border-b border-solid border-[#e1e0e0]">
            <div className="text-[18px] geomanistBook text-black">Cagnotte</div>

            <div className="flex items-center gap-2">
              <span className="text-[16px] geomanistBook bg-red-500 text-white rounded p-2">Indisponible</span>
            </div>
          </div>: null}
        </div>

        <div className={clsx("flex justify-between items-center py-7 px-5",
            "bg-white border border-solid border-gray-300 rounded-t-none rounded-bl-2xl rounded-br-2xl")}
            style={{ borderTop: '1px solid rgba(14, 11, 38, 0.1)' }}>
          <p className='text-[18px] geomanistBook text-black'>Total à payer</p>

          <div className="flex items-center gap-7">
          {hasPromo || jackpotMatchAmount > 0 ?
            <div className="promotion_sliced text-[16px] geomanistBook leading-8">
              {formatPriceWithEuro(cartItems.itemsPrice)}
            </div> : null}

            <p className="text-[18px] geomanistBold text-black">
              {formatPriceWithEuro(totalToPay)}
            </p>
          </div>
        </div>
      </div>
    )
  }
